export default __webpack_public_path__ + "static/media/filter.28dfadc7.svg";